export enum EventAvailabilityState {
  OnACall = 'On-A-Call',
  WrapupTime = 'Wrapup-Time',
  CallOffer = 'Call-Offer',
  OnExternalCall = 'On-External-Call',
}
